import React from 'react'

import { useStores } from 'presentation/hooks/use-stores'
import { Profile } from 'common/enum/profile'
import makeHospitalDoctorRegisterHome from './hospital-home-doctor-register-factory'
import makeHospitalSurgicalHome from './hospital-surgical-home-factory'
import makeHospitalPainAlerts from './pain-alerts/hospital-pain-alerts-factory'
import makeHospitalDirectorDoctorRegisterHome from './hospital-home-director-doctor-register-factory'
// import HospitalHomeOncology from 'presentation/hospital/pages/Home/Oncology'
// import makeHospitalAmbulatoryHome from './hospital-home-ambulatory-factory'
// import makeHospitalAdminSectorialCRMOHome from './hospital-home-admin-sectorial-crmo-factory'
// import makeHospitalEmergencyRoomHome from './hospital-home-emergency-room-factory'

export default function makeHospitalHome() {
  const stores = useStores()
  const currentUser = stores.currentAccount
  const role = currentUser.getCurrentAccount()?.user?.role

  return (
    <>
      {[Profile.CRMO, Profile.HOSPITAL].includes(role) &&
        makeHospitalSurgicalHome()}
      {role === Profile.HOSPITALIZATION && makeHospitalPainAlerts()}
      {role === Profile.DOCTOR_REGISTER && makeHospitalDoctorRegisterHome()}
      {role === Profile.DIRECTOR_DOCTOR_REGISTER &&
        makeHospitalDirectorDoctorRegisterHome()}
      {/* {role === 'ambulatory' ? makeHospitalAmbulatoryHome() : null}
      {role === 'oncology' ? <HospitalHomeOncology /> : null}
      {role === 'admin_sectorial_crmo'
        ? makeHospitalAdminSectorialCRMOHome()
        : null}
      {role === 'emergency_room' ? makeHospitalEmergencyRoomHome() : null} */}
    </>
  )
}
